const spaRoutes = {
    documents: (solutionId: string, workspaceId: string, viewId: string) => `/solution/${solutionId}/workspace/${workspaceId}/${viewId}`,
    upload: (solutionId: string, workspaceId: string, viewId: string) => `/solution/${solutionId}/workspace/${workspaceId}/${viewId}/upload`
}

export default spaRoutes;